module.exports = __webpack_public_path__ + "static/media/main.99c1140a.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/portfolio/lotterfree/main.png
// module id = 229
// module chunks = 0